<template>
    <div ></div>
</template>

<script lang="ts">
    /** Vue.js libs */
    import { Component } from 'vue-property-decorator';

    /** Overlay de chargement + logout */
    import { mixins } from 'vue-class-component';
    import { ConnectionUtils, OverlayUtils } from '@/components/commons/Utils';

    import AuthentificationMethodEnum from '@/enums/AuthentificationMethodEnum';
    import Dictionary from '@/types/Dictionary';

    /** Axio accès web api */
    import { API_URL } from '@/App.settings';
    import axios from 'axios';

    /** Page de connexion */
    @Component({ })
    export default class SignPage extends mixins( OverlayUtils, ConnectionUtils ) {
        async created() {
            if(this.$route.name === 'SignInOidc'){
                this.$bvToast.toast(this.$t('SessionExpiredMessage').toString(), {	// "Une erreur s'est produite lors du chargement des informations de session."
						title: this.$t('SessionExpired').toString(),
						autoHideDelay: 10000,
						variant: "info",
						solid: true,
						appendToast: true,
						toaster: "b-toaster-top-center"
					});

                await this.$store.dispatch("ShowLoadingMask", this.$t('LoginInProgress')); 
                
                /** Test si une session est déjà en cours */
                if( this.$cookies.get('access_token') ){
                    const args: Dictionary<any> = {};
                    args["Token"] = this.$cookies.get('access_token') != null ? <string>this.$cookies.get('access_token') : "";

                    await axios.post(API_URL + "Connexion/IsBaseSelected", args).then(async (response) => {
                        if (response && response.data) {
                            if(!response.data.isBaseSelected){
                                await this.$router.push({ name: 'Connexion' });
                            }else{
                                await this.$router.push({ name: 'Master' });
                            }
                        }
                    })
                }

                await this.$store.dispatch('AuthentificationStore/LoadFromKey', this.$route.params.key);
                const method = this.$store.getters['AuthentificationStore/GetConnectionMethod'];
                console.debug(method)
                if( method && method.method === AuthentificationMethodEnum.Oidc && method.oidcAuthority ){
                    await this.$store.dispatch('OidcStore/LoginOidc', { configuration: method.oidcAuthority });
                }
                await this.$store.dispatch("HideLoadingMask", {});
                this.$router.push({ name: 'Connexion' });
            }
            else if(this.$route.name === 'SignOut') {
                await this.logOut().finally(async () =>{
                    await this.$store.dispatch("HideLoadingMask", {});
                });
            }
            else if(this.$route.name === 'SignOutOidc'){
                await this.$store.dispatch("ShowLoadingMask", this.$t('LoginInProgress')); 
                await this.$store.dispatch('AuthentificationStore/Load');
                await this.$store.dispatch('OidcStore/HandleOidcLogoutCallback');
                await this.$store.dispatch("HideLoadingMask", {});
                this.$router.push({ name: 'Connexion' }).catch((e) => e);
            }else if(this.$route.name === 'SignInPartner'){
                //On ajoute le provider fournis dans l'URL dans les paramètres GET
                this.$route.query.authority = this.$route.params.provider; 
                this.$router.push({ name: 'Connexion', query: {...this.$route.query} });
            }
        }
    }
</script>

<style scoped>
</style>